<template>
  <div class="tabs border-bottom">
    <div
      v-for="tab in tabs"
      :key="tab"
      class="tab"
      :class="{ active: selectedTab === tab }"
      @click="selectTab(tab)"
    >
      {{ tab }}
      <span v-if="tab === 'Notifications'" class="badge">{{ notifications }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TabsBar',
  data() {
    return {
      tabs: ['Actions', 'Context', 'Notifications']
    }
  },
  computed: {
    ...mapState(['selectedTab', 'notifications'])
  },
  methods: {
    selectTab(tab) {
      this.$store.dispatch('selectTab', tab)
    }
  }
}
</script>